<template>
<div>
    <v-toolbar class="glass rounded-lg" flat>
        <v-toolbar-title>
           Our Services
        </v-toolbar-title>
        <v-spacer/>
        <v-dialog v-model="dialog" max-width="600">
                <template v-slot:activator="{ on, attrs}">
                    <v-btn color="primary" v-on="on" v-bind="attrs">
                        Add New
                    </v-btn>
                </template>

               <v-form @submit.prevent="addEditService">
                   <v-card>
                        <v-card-title class="mb-3">
                            {{ formTitle }}
                        </v-card-title>

                       <v-card-text>

                           <v-row>
                               <v-col>
                                   <v-file-input
                                       v-model="form.icon"
                                       label="Service Icon"
                                       prepend-icon=""
                                       prepend-inner-icon="mdi-camera"
                                       outlined
                                       class=""
                                       dense
                                       :error-messages="$page.props.errors.icon"
                                       accept="image/png, image/jpeg, image/bmp"
                                       persistent-hint
                                       :rules="[value => !value || value.size < 2000000 || 'Preview Image size should be less than 2 MB!',]"
                                       hint="Only .jpg or .png are allowed"
                                   />
                               </v-col>
                               <v-col>
                                   <img
                                       :src="previewFile(form.icon)"
                                       height="100px"
                                       class="ml-1"
                                       alt=""
                                   />
                               </v-col>
                           </v-row>
                           <v-text-field
                               outlined
                               dense
                               v-model="form.title"
                               label="Service Title"
                           />
                           <v-textarea
                               rows="3"
                               outlined
                               dense
                               v-model="form.details"
                               label="Service Details"
                           />
                       </v-card-text>

                       <v-card-actions>
                           <v-spacer/>
                           <v-btn @click="close" depressed outlined color="warning" class="mx-1">
                               Cancel
                           </v-btn>

                           <v-btn type="submit" depressed   color="success" class="mx-1">
                               Submit
                           </v-btn>
                       </v-card-actions>
                   </v-card>
               </v-form>
        </v-dialog>
    </v-toolbar>

    <v-card>
        <v-card-text>
            <v-data-table
                :headers="headers"
                :items="$page.props.services"
            >
                <template v-slot:item.icon="{ item }">
                    <img
                        :src="item.icon"
                        height="90px"
                        class="ml-1"
                        alt=""
                    />
                </template>


                <template v-slot:item.actions="{ item }">
                    <div class="d-flex">
                        <v-btn class="mx-1" small color="success" @click="editService(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn class="mx-1" small color="error" @click="deleteService(item)">
                            <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import AdminLayout from "../AdminLayout";
export default {
    name: "Index",
    layout:AdminLayout,
    data(){
        return {
            dialog:false,
            form:this.$inertia.form({
                id:null,
                icon:null,
                title:null,
                details:null,
            }),
            headers:[
                {text:'Title', value:'title'},
                {text:'Icon', value:'icon'},
                {text:'Detail', value:'details'},
                {text:'Actions', value:'actions',sortable:false},
            ]
        }
    },

    computed:{

        formTitle(){

            if(this.form.id){
                return 'Edit '+this.form.title+ ' Service'
            }else{
                return 'New Service'
            }
        }
    },

    methods:{
        addEditService(){
            this.form.post(route('admin.services.store'),{
                onSuccess:()=>{
                    this.close()
                }
            })
        },

        close(){
            this.form.reset()
            this.dialog = false
        },

        editService(service){
            this.form.id      = service.id
            this.form.icon    = service.icon
            this.form.title   = service.title
            this.form.details = service.details
            this.dialog = true
        },

        deleteService(service){
            Swal.fire({
                title: 'Are you sure?',
                text: ""+service.title+ " will be deleted!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {

                    this.$inertia.delete(route('admin.services.destroy',service.id),{
                        resetOnSuccess: false,
                        onSuccess: ()=>{
                            Toast.fire({
                                icon: 'success',
                                title: 'Service Deleted!'
                            })
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
